export const AUTH_CALLBACK_PATH = '/auth/callback'

// Cube Zone SSO 1.1.2 keeps the one-time return state, /login/ redirect,
// /status polling, and /resume handling inside WordPress. Land only starts
// that server-owned flow through this service-specific login URL.
export const WORDPRESS_LOGIN_URL =
  'https://roborisen.com/cube-zone/login?service=land'

export const WORDPRESS_LAUNCH_URL =
  'https://roborisen.com/cube-zone/launch?service=land'
